@for (substitution of substitutions; track substitution.userId) {
  <div class="mb-3">
    <input type="checkbox" [id]="'substitution-' + substitution.userId" [checked]="substitution.substituteActive"
           (change)="toggleSubstitution(substitution.userId)"/>
    <label
        [for]="'substitution-' + substitution.userId">{{ substitution.firstName + ' ' + substitution.lastName }}</label>
  </div>
}
